import _ from "lodash";
import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux";
import { loadDoctorCategoryList, updatePharmacyFilter } from "../../redux/reducer/timeslotReducer";
import { useTranslation } from "react-i18next";
import InputSearch from "../prenotationfilterBox/inputSearch";
import PharmacyBoxService from "./pharmacyBoxService";


const PharmaciesFilterList = ({...props}) => {
  const dispacth = useAppDispatch();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const { doctorCategoryPrenotation } = useSelector((state: any) => state.timeslot);
  const { user } = useSelector((state: any) => state.login);
  const { pharmacyFilter } = useSelector((state: any) => state.timeslot);

  useEffect(() => {
      dispacth(loadDoctorCategoryList(searchValue));
  }, [user,searchValue]);

  const toggleviewListServiceTimeslot = (id: any, status: any) => {
    let timeslotcategorys = _.cloneDeep(pharmacyFilter);
    if (!status) {
      timeslotcategorys.push(id)
    }
    else {
      _.remove(timeslotcategorys, timeslotcategory => timeslotcategory === id);
    }
    dispacth(updatePharmacyFilter(timeslotcategorys))
  }


  return (
    <div className="col-12 filterListContainer">
       <div className="col-lg-12 pb-2">
      <div className="row col-lg-12 border-lines m-0 p-1 pt-3 pb-3 d-flex align-item-center">
          <div
            className={`Marker ${props.onlyAssigned ? "Active" : ""} top-0`}
            onClick={()=>props.clickOnlyAssigned(!props.onlyAssigned)}>
          </div>

        <div className="col-lg-10">
          <p className="ellipsis-title m-0">
          {t('timeslot.filter-your-availability')}
          </p>
        </div>
      </div>
      </div>
      <div className="row col-lg-12 m-0 p-1">
          <div className="col-lg-12 pt-1 pl-0"><h6 className="Bold">{t('timeslot.filter-farmacia')}</h6></div>  
      </div>
      <div className="col-lg-12">
      <InputSearch
        placeholder={t("search")}
        handleClick={(e: any) => { setSearchValue(e)}}
      />
      </div>
      {doctorCategoryPrenotation.map((param: any, index: any) =>
       <PharmacyBoxService
          key={index}
          id={param._id}
          title={param.name}
          hash={param._hash}
          toggleClick={toggleviewListServiceTimeslot}
        />
    )}
    </div>
  )
}

export default PharmaciesFilterList